export enum ClickToTextRoutes {
  root = 'click-to-text',
  create = 'create',
  edit = 'edit',
  clone = 'clone',
  view = 'view',
}
